<template>
  <div steyle="width:100%;">
    <el-tooltip effect="dark" v-for="(item, index) in rscData">
      <div  :key="index" :class="[$style['perf-box'], isTrue(item.isAbnormal) ? $style.abnormal : null]">
        <div :class="[$style.label]">
          {{ item.rscLabel }}
          <i v-if="isTrue(item.isAbnormal)" :class="`${isTrue(exportingPdf) ? 'fas fa-exclamation-circle' : 'fad fa-exclamation-circle'}`" style="margin-left: 2px;"></i>
        </div>
        <div :class="[$style.value]">
          {{ item.valueLabel }}
        </div>
      </div>
      <div slot="content">
        {{item.rscLabel}}: {{item.valueLabel}}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { isNil, isEmpty, cloneDeep, forEach } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { dataTypeDefine } from '@/constants/performance';
import { isTrue } from '@/utils/boolean';

export default {
  name: 'WEventTimeAnalysisInfo',
  props: {
    eventHistData: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    exportingPdf: {
      type: Boolean,
    },
  },
  computed: {
    rscData() {
      if (isEmpty(this.data)) {
        return [];
      }
      const data = cloneDeep(this.data);
      forEach(data, (item) => {
        item.rscLabel = this.formatterForRscName(item);
        item.valueLabel = this.formatterForValue(item);
      });
      return data;
    },
  },
  methods: {
    isTrue,
    formatterForRscName(data) {
      return !isNil(data.rscKeyName) && data.rscKey !== '_' ? `${data.rscName} (${data.rscKeyName})` : data.rscName;
    },
    formatterForValue(data) {
      // #54345 Oracle VIP 전환 발생만 별도 값으로 치환
      if (data.managetypeId === 'DBMS' && data.rsctypeId === 'OR_VIPSTATUS' && data.rscId === 'OR_VIP_CHANGE') {
        const value = data.valueInteger;
        if (isNil(value)) {
          return EMPTY_TEXT;
        } else if (value === 1) {
          return '발생';
        } else if (value === 2) {
          return '정상';
        }
        return '확인 불가';
      }
      const datatypeId = data.rscDatatypeId;
      let value;
      if (datatypeId === dataTypeDefine.BOOL) {
        if (isNil(data.valueBoolean)) {
          return EMPTY_TEXT;
        }
        return isTrue(data.valueBoolean) ? 'UP' : 'DOWN';
      } else if (datatypeId === dataTypeDefine.INTEGER) {
        value = data.valueInteger;
      } else if (datatypeId === dataTypeDefine.DOUBLE) {
        value = data.valueDouble;
      } else {
        return getValueAfterCheckEmpty(data.valueString);
      }

      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, data.rscUnit);
    },
  },
};
</script>

<style lang="scss" module>
.perf-box {
  $box-shadow: 0 2px 5px -2px rgba(107, 106, 106, 0.6);
  width: 150px;
  height: 88px;
  // border: 1px solid #efefef;
  box-shadow: $box-shadow;
  background: #f2f2f3;
  display: inline-block;
  margin-right: 10px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 7px;
  position: relative; // PDF 출력시 텍스트 표현되지 않는 현상 처리

  &.abnormal {
    background: linear-gradient(145deg, #e43757, #e6923c);
    color: #fff;
    box-shadow: 0 2px 5px -2px rgba(165, 25, 25, 1);
  }

  .label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .value {
    font-weight: 600;
  }

  &:focus:active {
    box-shadow: $box-shadow !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EventTimeAnalysisInfo.vue